import script from "./FunctionalityNotSupported.vue?vue&type=script&setup=true&lang=ts"
export * from "./FunctionalityNotSupported.vue?vue&type=script&setup=true&lang=ts"

import "./FunctionalityNotSupported.vue?vue&type=style&index=0&id=2598de1d&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2598de1d"]])

export default __exports__